import { cn } from '@/utlis/cn'

export const cardXPad = 'px-[8px] md:px-[25px]'

type CardProps = {
    children?: React.ReactNode
    className?: string
    id?: string
}
export function Card(props: CardProps) {
    const bg = 'bg-[rgba(255,255,255,0.03)] py-[25px]'
    const border = 'rounded-[26px] border-muse-toplit-low'
    return (
        <div className={cn(bg, cardXPad, border, props.className)} id={props.id}>
            {props.children}
        </div>
    )
}
